import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const menuTrigger = $("[data-primary-toggle]");
  const menu = $("[data-primary-menu]");
  const header = $(".c-site-header");
  const navHeight = $(".c-aside-sidebar-nav").innerHeight();
  let isOpen = false;
  const toggleNav = () => {
    if (isOpen === false) {
      isOpen = true;

      $("body").addClass("scrollLock");
      menu.outerHeight($("body").innerHeight() - 70);
      menuTrigger.addClass("isOpen");
      header.addClass("isOpen");
      menu.addClass("active");
    } else {
      isOpen = false;
      menuTrigger.removeClass("isOpen");
      header.removeClass("isOpen");
      menu.removeClass("active");
      $("body").removeClass("scrollLock");
    }
  };

  const undoViewInMenu = () => {
    const submenu = $(".c-main-navigation__submenu");
    const parentItem = $("#menu-menu .menu-item-has-children");

    parentItem.each(function() {
      const self = $(this);
      const text = self.children(".c-main-navigation__link").text();
      const ul = self.children("ul");
      const li =
        '<li class="c-main-navigation__item back" data-single-filter="' +
        text +
        '">' +
        text +
        "</li>";

      ul.prepend(li);
      const goBack = (e, self) => {
        self.parent().removeClass("show");
        self
          .parent()
          .prev(".c-main-navigation__trigger")
          .removeClass("c-main-navigation__trigger--active");
      };

      $(".c-main-navigation__item.back").each(function() {
        let self = $(this);

        self.on("click", e => goBack(e, self));
      });
    });
  };

  const displayLabelInSubmenu = () => {
    const submenuLabel = $(".js-submenu-label a");

    submenuLabel.each(function() {
      let self = $(this);
      let text = self.attr("title");
      let textBold = text.substr(text.indexOf(":") + 1);
      let newStr = text.replace(textBold, "<strong>" + textBold + "</strong>");

      self.html(newStr);
    });
  };

  displayLabelInSubmenu();
  undoViewInMenu();
  menuTrigger.on("click", toggleNav);
})();
